import { identity } from "lodash";
import { FC } from "react";
import { Field, useField } from "react-final-form";
import { Descendant } from "slate";

import { FormField } from "@livechat/design-system-react-components";

import { Divider } from "components/divider/Divider";
import Flex from "components/layout/Flex";
import { FormattedTextEditor } from "components/rich-editor/formatted-text-editor";
import { FormBlockType, IFormBlockConsent } from "store/entities/contact-forms/interfaces";

import { RequiredErrorField } from "./parts/RequiredErrorField";

type Props = {
  name: string;
  blockType: FormBlockType;
};

export const ConsentBlock: FC<Props> = ({ name, blockType }) => {
  const isRequired = useField(name).input.value.required;

  return (
    <Flex column>
      <FormField labelText="Privacy consent content">
        <Field<Descendant[]>
          keepState
          parse={identity}
          name={`${name}.value.html`}
          render={FormattedTextEditor}
          linksPlugin
          richTextPlugin
          withBold
          withItalic
          withUnderline
          withStrikethrough
          richTextAreaMinHeight="unset"
        />
      </FormField>
      {isRequired && (
        <>
          <Divider />
          <Field<IFormBlockConsent["requiredError"]>
            name={`${name}.requiredError`}
            render={RequiredErrorField}
            blockType={blockType}
          />
        </>
      )}
    </Flex>
  );
};
